/* global REVIEWS_API_ENDPOINT */

import 'intersection-observer';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';

import Globals from './util/VueGlobals';
import App from './App.vue';
import {ROUTE_MODES} from './misc/Routes';
import store from './store/store';
import ReviewController from './ReviewController';
import { routes } from './routes';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(Globals);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(ReviewController);
Vue.use(VueObserveVisibility);

Vue.InitSnowplow();

Vue.http.options.root = REVIEWS_API_ENDPOINT;

window.Reviews = window.Reviews || {};
routes
	.filter((route) => route.name)
	.filter((route) => route.name !== 'dev')
	.forEach((route) => {
		window.Reviews[route.name] = new Vue({
			router: new VueRouter({
				mode: ROUTE_MODES.ABSTRACT,
				routes: [route]
			}),
			store,
			render: h => h(App)
		});
	});

Vue.LoadStylesheet('https://cdn.icomoon.io/26905/Studyportalslineariconset/style-cf.css?gpblw2');

// Auto mount the app for manual testing purposes.
if (Vue.isDevelopment() && !window.Cypress) {
	Vue.LoadStylesheet('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700');

	new Vue({
		router: new VueRouter({
			mode: ROUTE_MODES.HISTORY,
			routes
		}),
		store,
		render: h => h(App)
	}).$mount(Vue.appContainer());
}
